var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4V3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4H13V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V4H8ZM11 7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7V6H16V7C16 7.55228 16.4477 8 17 8C17.5523 8 18 7.55228 18 7V6H20V9H4L4 6H6V7C6 7.55228 6.44772 8 7 8C7.55228 8 8 7.55228 8 7V6H11V7ZM4 18V11H20V18H4Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCalendar);
export default __webpack_public_path__ + "static/media/new-calendar.3a3b654397a611d800b5711e77d8215c.svg";
export { ForwardRef as ReactComponent };